export const MapLayer = {
  VesselSymbolLayer: {
    id: "VesselSymbolLayer",
  },
  VesselSymbolFarLayer: {
    id: "VesselSymbolFarLayer",
  },
  VesselTextLayer: {
    id: "VesselTextLayer",
  },
  VesselCircleLayer: {
    id: "VesselCircleLayer",
  },
  VesselVectorLayer: {
    id: "VesselVectorLayer",
  },
  VesselPolygonLayer: {
    id: "VesselPolygonLayer",
  },
  VesselSizeWithoutLayer: {
    id: "VesselSizeWithoutLayer",
  },
  VesselWakeLineLayer: {
    id: "VesselWakeLineLayer",
  },
  VesselWakeLineLayerForClickEvent: {
    id: "VesselWakeLineLayerForClickEvent",
  },
  VesselTargetLayer: {
    id: "VesselTargetLayer",
  },
  OwnVesselMarkerLayer: {
    id: "OwnVesselMarkerLayer",
  },
  OwnVesselSymbolLayer: {
    id: "OwnVesselSymbolLayer",
  },
  OwnVesselPolygonLayer: {
    id: "OwnVesselPolygonLayer",
  },
  OwnVesselTextLayer: {
    id: "OwnVesselTextLayer",
  },
  OwnVesselSizeWithoutLayer: {
    id: "OwnVesselSizeWithoutLayer",
  },
  SelectedVesselSymbolLayer: {
    id: "SelectedVesselSymbolLayer",
  },
  SelectedVesselPolygonLayer: {
    id: "SelectedVesselPolygonLayer",
  },
  SelectedVesselTextLayer: {
    id: "SelectedVesselTextLayer",
  },
  SelectedVesselMarkerLayer: {
    id: "SelectedVesselMarkerLayer",
  },
  SelectedVesselSizeWithoutLayer: {
    id: "SelectedVesselSizeWithoutLayer",
  },
  AnchorVesselMarkerLayer: {
    id: "AnchorVesselMarkerLayer",
  },
  AnchorVesselSymbolLayer: {
    id: "AnchorVesselSymbolLayer",
  },
  AnchorVesselPolygonLayer: {
    id: "AnchorVesselPolygonLayer",
  },
  AnchorVesselTextLayer: {
    id: "AnchorVesselTextLayer",
  },
  AnchorVesselSizeWithoutLayer: {
    id: "AnchorVesselSizeWithoutLayer",
  },
};

export const MapSource = {
  VesselPointSource: {
    id: "VesselPointSource",
  },
  VesselVectorSource: {
    id: "VesselVectorSource",
  },
  VesselPolygonSource: {
    id: "VesselPolygonSource",
  },
  VesselWakeLineSource: {
    id: "VesselWakeLineSource",
  },
  VesselWakeLineSourceForClickEvent: {
    id: "VesselWakeLineSourceForClickEvent",
  },
  VesselTargetSource: {
    id: "VesselTargetSource",
  },
  OwnVesselMarkerSource: {
    id: "OwnVesselMarkerSource",
  },
  OwnVesselPointSource: {
    id: "OwnVesselPointSource",
  },
  OwnVesselPolygonSource: {
    id: "OwnVesselPolygonSource",
  },
  SelectedVesselPointSource: {
    id: "SelectedVesselPointSource",
  },
  SelectedVesselPolygonSource: {
    id: "SelectedVesselPolygonSource",
  },
  SelectedVesselMarkerSource: {
    id: "SelectedVesselMarkerSource",
  },
  /** アンカーのポイント */
  AnchorPointSource: {
    id: "AnchorPointSource",
  },
  /** アンカーと船舶を結ぶ線 */
  AnchorToVesselLineSource: {
    id: "AnchorToVesselLineSource",
  },
  /** アンカー船 */
  AnchorVesselPolygonSource: {
    id: "AnchorVesselPolygonSource",
  },
  AnchorVesselPointSource: {
    id: "AnchorVesselPointSource",
  },
  AnchorVesselMarkerSource: {
    id: "AnchorVesselMarkerSource",
  },
  /** 石材ストック */
  BaseStationSource: {
    id: "BaseStationSource",
  },
  /** 運搬先 */
  DestinationSource: {
    id: "DestinationSource",
  },
};

export const LiveVesselMapLayer = {
  LiveVesselTextLayer: {
    id: "LiveVesselTextLayer",
  },
  LiveVesselSymbolLayer: {
    id: "LiveVesselSymbolLayer",
  },
  LiveVesselSymbolWithoutSizeLayer: {
    id: "LiveVesselSymbolWithoutSizeLayer",
  },
  LiveVesselWakeLineLayer: {
    id: "LiveVesselWakeLineLayer",
  },
  LiveVesselWakeLineLayerForClickEvent: {
    id: "LiveVesselWakeLineLayerForClickEvent",
  },
  LiveVesselPolygonLayer: {
    id: "LiveVesselPolygonLayer",
  },
  LiveVesselWithoutSizeLayer: {
    id: "LiveVesselWithoutSizeLayer",
  },
  LiveVesselVectorLayer: {
    id: "LiveVesselVectorLayer",
  },
  LiveVesselPulsingLayer: {
    id: "LiveVesselPulsingLayer",
  },
};

export const LiveVesselMapSource = {
  LiveVesselTextSource: {
    id: "LiveVesselTextSource",
  },
  LiveVesselSymbolSource: {
    id: "LiveVesselSymbolSource",
  },
  LiveVesselWakeLineSource: {
    id: "LiveVesselWakeLineSource",
  },
  LiveVesselWakeLineSourceForClickEvent: {
    id: "LiveVesselWakeLineSourceForClickEvent",
  },
  LiveVesselPolygonSource: {
    id: "LiveVesselPolygonSource",
  },
  LiveVesselWithoutSizeSource: {
    id: "LiveVesselWithoutSizeSource",
  },
  LiveVesselVectorSource: {
    id: "LiveVesselVectorSource",
  },
  LiveVesselPulsingSource: {
    id: "LiveVesselPulsingSource",
  },
};

export const VoyageHistoryMapLayer = {
  VoyageHistoryVesselTextLayer: {
    id: "VoyageHistoryVesselTextLayer",
  },
  VoyageHistoryVesselSymbolLayer: {
    id: "VoyageHistoryVesselSymbolLayer",
  },
  VoyageHistoryVesselWakeLineLayer: {
    id: "VoyageHistoryVesselWakeLineLayer",
  },
  VoyageHistoryVesselPolygonLayer: {
    id: "VoyageHistoryVesselPolygonLayer",
  },
  VoyageHistoryVesselWithoutSizeLayer: {
    id: "VoyageHistoryVesselWithoutSizeLayer",
  },
};

export const VoyageHistoryMapSource = {
  VoyageHistoryVesselMapSource: {
    id: "VoyageHistoryVesselMapSource",
  },
  VoyageHistoryVesselTextSource: {
    id: "VoyageHistoryVesselTextSource",
  },
  VoyageHistoryVesselSymbolSource: {
    id: "VoyageHistoryVesselSymbolSource",
  },
  VoyageHistoryVesselWakeLineSource: {
    id: "VoyageHistoryVesselWakeLineSource",
  },
  VoyageHistoryVesselPolygonSource: {
    id: "VoyageHistoryVesselPolygonSource",
  },
  VoyageHistoryVesselWithoutSizeSource: {
    id: "VoyageHistoryVesselWithoutSizeSource",
  },
};
/** パブリックレイヤー */
export const PlotMapLayer = {
  PlotTextLayer: {
    id: "PlotTextLayer",
  },
  PlotPolygonTextLayer: {
    id: "PlotPolygonTextLayer",
  },
  PlotSymbolLayer: {
    id: "PlotSymbolLayer",
  },
  PlotPolygonLayer: {
    id: "PlotPolygonLayer",
  },
};

export const PlotMapSource = {
  PlotPointSource: {
    id: "PlotPointSource",
  },
  PlotPolygonSource: {
    id: "PlotPolygonSource",
  },
};

/** プライベートレイヤー */
export const PrivatePlotMapLayer = {
  PrivatePlotTextLayer: {
    id: "PrivatePlotTextLayer",
  },
  PrivatePlotPolygonTextLayer: {
    id: "PrivatePlotPolygonTextLayer",
  },
  PrivatePlotSymbolLayer: {
    id: "PrivatePlotSymbolLayer",
  },
  PrivatePlotPolygonLayer: {
    id: "PrivatePlotPolygonLayer",
  },
};

export const PrivatePlotMapSource = {
  PrivatePlotPointSource: {
    id: "PrivatePlotPointSource",
  },
  PrivatePlotPolygonSource: {
    id: "PrivatePlotPolygonSource",
  },
};

export const PlotEditMapLayer = {
  PlotEditPolygonLayer: {
    id: "PlotEditPolygonLayer",
  },
  PlotEditLineLayer: {
    id: "PlotEditLineLayer",
  },
  PlotEditCircleLayer: {
    id: "PlotEditCircleLayer",
  },
  PlotEditSymbolLayer: {
    id: "PlotEditSymbolLayer",
  },
};

export const PlotEditMapSource = {
  PlotEditPointSource: {
    id: "PlotEditPointSource",
  },
  PlotEditPolygonSource: {
    id: "PlotEditPolygonSource",
  },
};

export const PolarisMapSource = {
  PolarisOffingWavePointSource: {
    id: "PolarisOffingWavePointSource",
  },
};

/** アンカー用のレイヤー */
export const AnchorPointsMapLayer = {
  AnchorPointLayer: {
    id: "AnchorPointLayer",
  },
  AnchorToVesselLineLayer: {
    id: "AnchorToVesselLineLayer",
  },
};

/** 拠点・基地局用のレイヤー */
export const BaseStationMapLayer = {
  BaseStationLayer: {
    id: "BaseStationLayer",
  },
};

/** 運搬先用のレイヤー */
export const DestinationMapLayer = {
  DestinationLayer: {
    id: "DestinationLayer",
  },
};

/** プロットよりもクリックイベントを優先するレイヤ */
// TODO: MapLayerのうち、clickイベントがついていないものなど、
// plotより優先しないものについてはコメントアウト中
export const LayersHigherClickPriorityThanPlot = [
  MapLayer.VesselSymbolLayer.id,
  MapLayer.VesselSymbolFarLayer.id,
  // MapLayer.VesselTextLayer.id,
  MapLayer.VesselCircleLayer.id,
  // MapLayer.VesselVectorLayer.id,
  MapLayer.VesselPolygonLayer.id,
  MapLayer.VesselSizeWithoutLayer.id,
  // MapLayer.VesselWakeLineLayer.id,
  // MapLayer.VesselWakeLineLayerForClickEvent.id,
  // MapLayer.VesselTargetLayer.id,
  MapLayer.OwnVesselMarkerLayer.id,
  MapLayer.OwnVesselSymbolLayer.id,
  MapLayer.OwnVesselPolygonLayer.id,
  // MapLayer.OwnVesselTextLayer.id,
  MapLayer.OwnVesselSizeWithoutLayer.id,
  MapLayer.SelectedVesselSymbolLayer.id,
  MapLayer.SelectedVesselPolygonLayer.id,
  // MapLayer.SelectedVesselTextLayer.id,
  MapLayer.SelectedVesselMarkerLayer.id,
  MapLayer.SelectedVesselSizeWithoutLayer.id,
  MapLayer.AnchorVesselMarkerLayer.id,
  MapLayer.AnchorVesselSymbolLayer.id,
  MapLayer.AnchorVesselPolygonLayer.id,
  // MapLayer.AnchorVesselTextLayer.id,
  MapLayer.AnchorVesselSizeWithoutLayer.id,
];
